import { sum } from 'lib/array/arrayUtils'

export const TRANSFERZ_MEET_GREET_EXTRA_TYPE = 'MEET_GREET'

export function isIncludedTransferzMeetGreetExtra(
  extra: Pick<App.ExperienceTransferExtra, 'type' | 'price'>,
): boolean {
  return extra.type === TRANSFERZ_MEET_GREET_EXTRA_TYPE && extra.price === 0
}

export function getIncludedTransferzExtras(
  availableExtras: Array<App.ExperienceTransferExtra> | undefined,
): Array<App.ExperienceTransferSelectedExtra> | undefined {
  const includedExtras = availableExtras
    ?.filter(isIncludedTransferzMeetGreetExtra)
    .map(extra => ({
      id: extra.id,
      title: extra.title,
      price: extra.price,
      quantity: 1,
    }))

  return includedExtras?.length ? includedExtras : undefined
}

export interface IncludedTransferzMeetGreetInfo {
  title: string
  description?: string
}

export function getSelectedIncludedTransferzMeetGreetInfo(
  legs: Array<{
    availableExtras: Array<App.ExperienceTransferExtra> | undefined
    selectedExtras: Array<App.ExperienceTransferSelectedExtra> | undefined
  }>,
): IncludedTransferzMeetGreetInfo | undefined {
  const selectedIncluded = legs.flatMap((leg) => {
    const includedExtras = leg.availableExtras?.filter(isIncludedTransferzMeetGreetExtra) ?? []

    return includedExtras.filter(extra => leg.selectedExtras?.some(selected => selected.id === extra.id && selected.quantity > 0))
  })

  if (!selectedIncluded.length) return undefined

  const descriptions = new Set(selectedIncluded.flatMap(extra => extra.description ? [extra.description] : []))

  return {
    title: selectedIncluded[0].title,
    description: descriptions.size === 1 ? [...descriptions][0] : undefined,
  }
}

export function hasSelectedIncludedTransferzMeetGreet(
  availableExtras: Array<App.ExperienceTransferExtra> | undefined,
  selectedExtras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): boolean {
  const includedExtraIds = new Set(getIncludedTransferzExtras(availableExtras)?.map(extra => extra.id))

  return selectedExtras?.some(extra => includedExtraIds.has(extra.id) && extra.quantity > 0) ?? false
}

export function getSelectedTransferExtras(
  extras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): Array<App.ExperienceTransferSelectedExtra> | undefined {
  const selectedExtras = extras?.filter(extra => extra.quantity > 0)

  return selectedExtras?.length ? selectedExtras : undefined
}

export function getTransferExtrasTotal(
  extras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): number {
  return sum(getSelectedTransferExtras(extras) ?? [], extra => extra.price * extra.quantity)
}
